import './Categories.css';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import sanityClient from '../../sanityClient';
import { postCategoryQuery } from '../../queries/postQuery';
import { categoryQuery } from '../../queries/categoryQuery';
import { StandardLayout } from '../../layouts/StandardLayout';
import { PostGrid } from '../../components/PostGrid/PostGrid';

export default function SingleCategory(){
    const [categoryData, setCategoryData] = useState(null);
    const [postData, setPostData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { slug } = useParams();

    useEffect(() => {
        if (!slug) return;

        setIsLoading(true);
        sanityClient
        .fetch(categoryQuery, {slug})
        .then((data) => {
            if (data) {
                setCategoryData(data);
                return data;
            } else {
                setError('Category not found.');
                throw new Error('Category not found.');
            }
        })
        .then((category) => {
            const categoryId = category._id;
            return sanityClient.fetch(postCategoryQuery, {categoryId: categoryId})
        }).then((data) => {
            if(data){
                setPostData(data);
            } else{
                setError('Posts not found.');
            }
            setIsLoading(false);
        })
        .catch((err) => {
            console.error(err);
            setError('Failed to fetch posts.');
            setIsLoading(false);
        });
    }, [slug]);

    if (isLoading) {
      return <StandardLayout title="Loading..." content="Loading..." />;
    }

    if (error) {
      return <StandardLayout title="Error" content={error} />;
    }
    
    if (!categoryData) {
      return <StandardLayout title="Not Found" content="This category could not be found." />;
    }

    let content = null;
    if(postData.length === 0){
        content = 'No posts yet for this category.'
    } else{
        content = 
        <>
            <div className='contributorTile'>
                <h4 className='contributorName'>{categoryData.title}</h4>
                <div className='contributorBio'>
                    {categoryData.description}
                </div>
            </div>
            <PostGrid posts={postData} />
        </>
    }
    
    return(
        <StandardLayout title={`all posts tagged with "${categoryData.title}"`} content={content} />
    )
}